<script>
export default {
    name: 'oc-heading',
    functional: true,
    props: {
        level: {
            type: [Number, String],
            required: true
        },
        text: {
            type: [String, Number]
        }
    },
    render: function (createElement, context) {
        return createElement(
            'h' + context.props.level,
            Object.assign({}, context.data, {
                on: context.listeners
            }),
            context.slots().default || context.props.text
        )
    }
}
</script>
